<template>
<div>
    <h1 class="text-h5 my-5">
        Projects
        <v-progress-circular v-if="loading" indeterminate color="green" size="30" class="ml-2"/>
    </h1>
    <v-alert v-if="alert.msg" :color="alert.color" icon="mdi-alert-octagon-outline" outlined text dismissible>
        {{alert.msg}}
    </v-alert>
    <v-simple-table>
        <thead>
        <tr>
            <th>Project</th>
            <th>Status</th>
            <th>Nodes</th>
            <th>Kubernetes</th>
            <th>Databases</th>
            <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="p in projects.concat(this.new)">
            <td>
                <TextInputInline
                    v-model="p.name" :rules="[$validators.notEmpty, $validators.isSlug]"
                    :to="p.id ? {name: 'project', params: {projectId: p.id}} : null"
                    :open="!p.id" @input="(v) => save(p.id, v)" @cancel="cancel" :disabled="!canEdit"/>
            </td>
            <td>
                <template v-if="p.connect">
                    <div>
                        <Led :status="p.connect.status" />{{p.connect.message}}
                        <ProjectConnect :projects="projects" :token="p.token" :open="projects.length === 1 && p.connect.status === 'unknown' && !p.agent" class="ml-1" />
                    </div>
                    <div v-if="p.connect.version" class="caption grey--text text-no-wrap">coroot-connect:{{p.connect.version}}</div>
                </template>
            </td>
            <td>
                <template v-if="p.agent">
                    <div><Led :status="p.agent.status" />{{p.agent.message}}</div>
                    <div v-if="p.agent.version" class="caption grey--text text-no-wrap">node-agent:{{p.agent.version}}</div>
                </template>
            </td>
            <td>
                <template v-if="p.kubernetes">
                    <div class="text-no-wrap"><Led :status="p.kubernetes.status" />{{p.kubernetes.message}}</div>
                </template>
            </td>
            <td>
                <Exporters :projectId="p.id" :exporters="p.exporters" />
            </td>
            <td>
                <ProjectDelete :workspaceId="workspaceId" :projectId="p.id" :name="p.name" :disabled="!canEdit" />
            </td>
        </tr>
        </tbody>
    </v-simple-table>
    <v-btn color="primary" @click="add" :disabled="!canEdit" class="mt-4">
        Add a project
    </v-btn>
</div>
</template>

<script>
import Led from "@coroot/coroot/src/components/Led.vue";
import TextInputInline from "@/components/TextInputInline.vue";
import ProjectConnect from "@/pages/console/ProjectConnect.vue";
import ProjectDelete from "@/pages/console/ProjectDelete.vue";
import Exporters from "@/pages/console/Exporters.vue";

export default {
    components: {Led, TextInputInline, ProjectConnect, ProjectDelete, Exporters},
    props: {
        workspaceId: String,
    },

    data() {
        return {
            access: '',
            loading: false,
            alert: {msg: '', color: ''},
            projects: [],
            new: [],

            edit: '',

            refresher: null,
        };
    },

    computed: {
        canEdit() {
            return this.access === 'edit';
        },
    },

    mounted() {
        this.get();
        this.$events.watch(this, this.get, 'refresh');
        this.refresher = setInterval(this.get, 3000);
    },
    beforeDestroy() {
        this.refresher && clearInterval(this.refresher);
    },

    methods: {
        get() {
            this.loading = true;
            // this.alert.msg = '';
            this.$api.getProjects(this.workspaceId, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.alert.msg = 'Failed to get projects. Please try again later.'
                    this.alert.color = 'red';
                }
                this.access = data.access;
                this.projects = data.projects || [];
                if (!this.canEdit) {
                    this.alert.msg = 'You are not allowed to configure projects.'
                    this.alert.color = 'primary';
                }
            })
        },
        add() {
            if (!this.canEdit) {
                return;
            }
            if (this.new.length) {
                return;
            }
            this.new.push({id: '', name: '', token: ''});
        },
        cancel() {
            this.new.pop();
        },
        save(id, name) {
            this.loading = true;
            this.error = '';
            this.$api.saveProject(this.workspaceId, id, {name}, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.alert.msg = 'Failed to save project. Please try again later.'
                    this.alert.color = 'red';
                    return;
                }
                this.$events.emit('refresh', null);
                if (!id) {
                    this.new.pop();
                }
                this.get();
            })
        },
    },
}
</script>

<style scoped>
tr:hover {
    background-color: unset !important;
}
td {
    padding: 8px 16px !important;
}
</style>